export default {
  MilesPerStop: {
    title: "Miles Per Stop",
    chartType: "line",
    dataKey1: "value",
    dataKey2: "goal",
    Xkey: "planDate",
    chartlable1: "Miles Per Stop",
    chartlable2: "Goal",
    ChartStyle: { width: "95%", height: "300px" },
    routeChart: {
      title: "Miles Per Stop",
      chartType: "bar",
      dataKey1: "milesPerStop",
      dataKey2: null,
      Xkey: "routeName",
      chartlable1: "Miles Per Stop",
      chartlable2: null,
      ChartStyle: { width: "95%", height: "80%" },
    },
  },
  BillsPerTrip: {
    title: "Bills Per Trip",
    chartType: "line",
    dataKey1: "value",
    dataKey2: "goal",
    Xkey: "planDate",
    chartlable1: "Bills Per Trip",
    chartlable2: "Goal",
    ChartStyle: { width: "95%", height: "300px" },
    routeChart: {
      title: "Bills Per Trip",
      chartType: "bar",
      dataKey1: "billsPerStop",
      dataKey2: null,
      Xkey: "routeName",
      chartlable1: "Bills Per Trip",
      chartlable2: null,
      ChartStyle: { width: "95%", height: "80%" },
    },
  },
  StopsPerHour: {
    title: "Stops Per Hour",
    chartType: "line",
    dataKey1: "value",
    dataKey2: "goal",
    Xkey: "planDate",
    chartlable1: "Stops Per Hour",
    chartlable2: "Goal",
    ChartStyle: { width: "95%", height: "300px" },
    routeChart: {
      title: "Stops Per Hour",
      chartType: "bar",
      dataKey1: "stopsPerHour",
      dataKey2: null,
      Xkey: "routeName",
      chartlable1: "Stops Per Hour",
      chartlable2: null,
      ChartStyle: { width: "95%", height: "80%" },
    },
  },
  "Missed Apts": {
    title: "Missed Appointments",
    chartType: "line",
    dataKey1: "value",
    dataKey2: null,
    Xkey: "planDate",
    chartlable1: "Missed Appointments",
    chartlable2: null,
    ChartStyle: { width: "95%", height: "300px" },
    routeChart: {
      title: "Missed Appointments",
      chartType: "bar",
      dataKey1: "numServiceViolations",
      dataKey2: null,
      Xkey: "routeName",
      chartlable1: "Missed Appointments",
      chartlable2: null,
      ChartStyle: { width: "95%", height: "80%" },
    },
  },
  "Total Miles": {
    title: "Total Miles",
    chartType: "line",
    dataKey1: "value",
    dataKey2: null,
    Xkey: "planDate",
    chartlable1: "Total Miles",
    chartlable2: null,
    ChartStyle: { width: "95%", height: "300px" },
    routeChart: {
      title: "Total Miles",
      chartType: "stackedBar",
      dataKey1: "onAreaMiles",
      dataKey2: "stemMiles",
      Xkey: "routeName",
      chartlable1: "On Area Miles",
      chartlable2: "Stem Miles",
      ChartStyle: { width: "95%", height: "80%" },
    },
  },
  "Total hours": {
    title: "Total Hours",
    chartType: "line",
    dataKey1: "value",
    dataKey2: null,
    Xkey: "planDate",
    chartlable1: "Total Hours",
    chartlable2: null,
    ChartStyle: { width: "95%", height: "300px" },
    routeChart: {
      title: "Total Hours",
      chartType: "stackedBar",
      dataKey1: "totalHours",
      dataKey2: "stopTime",
      Xkey: "routeName",
      chartlable1: "Windshield Hours",
      chartlable2: "Stop Time",
      ChartStyle: { width: "95%", height: "80%" },
    },
  },
  Routes: {
    title: "Total Routes",
    chartType: "line",
    dataKey1: "value",
    dataKey2: null,
    Xkey: "planDate",
    chartlable1: "Routes",
    chartlable2: null,
    ChartStyle: { width: "95%", height: "300px" },
    routeChart: {
      title: "Routes Empty Time",
      chartType: "bar",
      dataKey1: "value",
      dataKey2: null,
      Xkey: "name",
      chartlable1: "Empty Time",
      chartlable2: null,
      ChartStyle: { width: "95%", height: "80%" },
    },
  },
  "Total Bills": {
    title: "Total Bills",
    chartType: "stackedBar",
    dataKey1: "goal",
    dataKey2: "value",
    Xkey: "planDate",
    chartlable1: "Delivery Bills",
    chartlable2: "Trap Bills",
    ChartStyle: { width: "95%", height: "300px" },
    routeChart: {
      title: "Delivery Bills",
      chartType: "bar",
      dataKey1: "deliveryBills",
      dataKey2: null,
      Xkey: "routeName",
      chartlable1: "Delivery Bills",
      chartlable2: null,
      ChartStyle: { width: "95%", height: "80%" },
    },
  },
  Stops: {
    title: "Total Stops",
    chartType: "line",
    dataKey1: "value",
    dataKey2: null,
    Xkey: "planDate",
    chartlable1: "Stops",
    chartlable2: null,
    ChartStyle: { width: "95%", height: "300px" },
    routeChart: {
      title: "Stops",
      chartType: "bar",
      dataKey1: "stops",
      dataKey2: null,
      Xkey: "routeName",
      chartlable1: "Stops",
      chartlable2: null,
      ChartStyle: { width: "95%", height: "80%" },
    },
  },
  chartColors: {
    planning: {
      color: "#05A792",
      stackedColor: "#8884d8",
      goalColor: "#666666",
    },
    dispatch: {
      color: "#4863A0",
      stackedColor: "#76AFBB",
      goalColor: "#666666",
    },
    line: {
      stroke: "#f5f5f5"
    },
    customLabel: "#666666"
  }
};